import { FC, SVGProps } from 'react'

export const Pillow: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M3.76489 6.99651V16.5035C3.78614 16.5325 3.86016 16.6139 4.08521 16.7189C4.43063 16.8801 4.96056 17 5.58632 17H18.4435C19.0692 17 19.5991 16.8801 19.9446 16.7189C20.1696 16.6139 20.2436 16.5325 20.2649 16.5035V6.99651C20.2436 6.96746 20.1696 6.88613 19.9446 6.78111C19.5991 6.61991 19.0692 6.5 18.4435 6.5H5.58632C4.96056 6.5 4.43063 6.61991 4.08521 6.78111C3.86016 6.88613 3.78614 6.96746 3.76489 6.99651ZM3.45088 5.42183C4.03613 5.14872 4.79192 5 5.58632 5H18.4435C19.2379 5 19.9937 5.14872 20.5789 5.42183C21.1033 5.66653 21.7649 6.15415 21.7649 6.95V16.55C21.7649 17.3458 21.1033 17.8335 20.5789 18.0782C19.9937 18.3513 19.2379 18.5 18.4435 18.5H5.58632C4.79192 18.5 4.03613 18.3513 3.45088 18.0782C2.92653 17.8335 2.26489 17.3458 2.26489 16.55V6.95C2.26489 6.15415 2.92653 5.66653 3.45088 5.42183Z"
			fill="currentColor"
		/>
	</svg>
)
